<!--
 * @Author: wangjx
 * @LastEditors: yingna.gao
 * @Date: 2022-02-16 11:19:48
 * @LastEditTime: 2022-08-30 11:18:30
 * @Description: 功能权限
-->
<template>
  <div id="APFunction" v-loading="loading" class="h100 w100">
    <div style="display: flex;justify-content: space-between;">
      <div class="mt-1 ml-10">
        <el-radio-group v-model="treeType" size="small" class="tree-tabs-wrapper">
          <el-radio-button label="WEB"></el-radio-button>
          <el-radio-button label="APP"></el-radio-button>
        </el-radio-group>
      </div>
      <div style="flex:1">
        <div class="h-8 flex justify-between pr-5 mt-3 ml-5 mb-3">
          <div class="h-full flex pl-5">
            <div class="sicm-text-color fn14 w-32 mt-2">
              <el-checkbox v-model="showCheck" @change="showPermission"></el-checkbox>
              <span class="ml-1">仅显示授权</span>
            </div>
            <div v-if="!disabled" class="sicm-text-color fn14 pl-31 mt-2">
              <el-checkbox v-model="strictly"></el-checkbox>
              <span class="ml-1">父子联动</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mr-10 mt-3">
        <el-button
          v-if="!disabled"
          type="primary"
          :disabled="treeData.length === 0"
          :loading="saving"
          class="w-20"
          @click="handleConfirm()"
        >
          保存
        </el-button>
      </div>
    </div>


    <!--<el-tabs v-model="treeType" class="ml-5 mr-5">
      <el-tab-pane
        v-for="item in treeTabs"
        :key="item.value"
        :label="item.label"
        :name="item.value"
      ></el-tab-pane>
    </el-tabs>-->



    <menuTree
      ref="menuTree"
      v-loading="loadingTree"
      class="menu_tree pl-5 pr-5"
      :strictly="strictly"
      :tree-data="treeData"
      :default-expanded-keys="defaultExpandedKeys"
      :default-checked-keys="defaultCheckedKeys"
      :filter-node-method="filterNode"
    ></menuTree>
  </div>
</template>

<script>
import resourceApi from "@/api/data-permission/dataPermission";
import menuTree from "./permission-menu-tree.vue";

export default {
  name: "APFunction",
  components: {
    menuTree
  },
  props: {
    targetId: {
      type: String,
      default() {
        return "";
      }
    },
    targetType: {
      type: String,
      default() {
        return "2";
      }
    },
    clientType: {
      type: String,
      default() {
        return "WEB";
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      strictly: false,
      showCheck: false,
      treeData: [],
      saving: false,
      loadingTree: false,
      defaultExpandedKeys: [],
      // 默认选择的菜单
      defaultCheckedKeys: [],
      treeType: "WEB",
      treeTabs: [
        {
          value: "WEB",
          label: "WEB"
        },
        {
          label: "APP",
          value: "APP"
        }
      ]
    };
  },
  watch: {
    targetId() {
      this.loadTree();
    },
    treeType() {
      this.strictly = false;
      this.showCheck = false;
      this.loadTree();
    }
  },
  mounted() {
    this.loadTree();
  },
  methods: {
    /**
     * @description: 获取功能树
     * @param {*}
     * @return {*}
     */
    loadTree() {
      this.treeData = [];
      this.defaultExpandedKeys = [];
      this.defaultCheckedKeys = [];
      this.strictly = false;
      if (this.targetId) {
        this.loadingTree = true;
        resourceApi
          .getPermissionTree(this.targetId, this.targetType, this.treeType, { parseToTree: true })
          .then(res => {
            this.loadingTree = false;
            if (res && res.success) {
              this.handleTreeData(res.data);
              this.treeData = res.data;
            }
            this.$nextTick(() => {
              if (this.showCheck) {
                this.$refs.menuTree.filter(this.showCheck);
              }
            });
          })
          .catch(() => {
            this.loadingTree = false;
          });
      }
    },

    /**
     * @description:
     * @param {*} children
     * @return {*}
     */
    handleTreeData(children) {
      children.forEach(element => {
        if (element.ac) {
          this.defaultCheckedKeys.push(element.id);
        }
        element.label = element.resourceName;
        if (this.disabled) {
          element.disabled = true;
        }
        const { resourceType } = element;
        element.icon =
          resourceType === "DIRECTORY"
            ? "icon_floder"
            : resourceType === "MENU"
              ? "icon_menu"
              : resourceType === "BUTTON"
                ? "icon_button"
                : "";
        if (element.children) {
          this.handleTreeData(element.children);
        }
      });
    },

    filterNode(value, data, node) {
      // 将某一层级的所有节点名称放入到数组中，如果包含当前节点名，则保留显示
      if (!value) {
        return true;
      }
      return node.checked;
    },

    showPermission(checked) {
      this.$refs.menuTree.filter(checked);
    },

    handleConfirm() {
      const nodes = this.$refs.menuTree.getCheckedNodes();
      const halfNodes = this.$refs.menuTree.getHalfCheckedNodes();
      const allNodes = [...nodes, ...halfNodes];
      const keys = [];
      const btnKeys = [];
      allNodes.forEach(element => {
        // sourceType 来源（1-菜单管理的数据，0-资源管理的数据）
        if (element.sourceType === 0) {
          btnKeys.push(element.id);
        } else {
          keys.push(element.id);
        }
      });
      const data = {
        clientType: this.treeType,
        resourceKeys: {
          keys,
          operation: "REPLACE"
        }
      };
      this.saving = true;
      resourceApi
        .saveFunctionList(this.targetId, this.targetType, data)
        .then(res => {
          this.saving = false;
          if (res && res.success) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "保存失败",
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style lang="scss">
#APFunction {
  .menu_tree {
    height: calc(100% - 63px);
  }
}
</style>
<style lang="scss">
  .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 103px;
      font-size: 12px!important;
    }
  }
</style>
